import FetchExtension from '@/core/extensions/FetchExtension';
// service 
import OdataCoreServiceBase from '@/core/services/OdataCoreServiceBase';
// interface
import TFetchExtension from '@/core/types/TFetchExtension';
import { IOdataDetailsRequest } from '@/core/types/TDetailsRequest';
// enum
import HttpMethodEnum from '@/core/enums/EHttpMethod';
import EndpointProtocol from '@/core/enums/EEndpointProtocol';


class OdataReadOnlyServiceBase extends OdataCoreServiceBase {

	async details( params: IOdataDetailsRequest ): Promise<any> {

		const apiFetchConfig: TFetchExtension = {
            // protocol: EndpointProtocol.ODATA,
			method: HttpMethodEnum.GET,
            language: params.language,

			sourcePath: `${this.sourcePath}/${params.key}/details`,
		}

		return FetchExtension(apiFetchConfig);
	
    }

}

export default OdataReadOnlyServiceBase;
